// export const extractCityFromLocation = (assignedLocation) => {
//   if (!assignedLocation) return "Unknown";
//   if (
//     assignedLocation
//       .toLowerCase()
//       .includes("Mohali" || "Kharar" || "Chandigarh" || "Daria")
//   ) {
//     return "Mohali";
//   }
//   if (assignedLocation.toLowerCase().includes("New Delhi" || "Delhi")) {
//     return "Delhi";
//   }
//   // Split the location string by commas
//   const locationParts = assignedLocation.split(",");

//   // Return the second-to-last element if it exists
//   const lastThirdPart =
//     locationParts.length >= 3
//       ? locationParts[locationParts.length - 3].trim()
//       : "Unknown";

//   const city = lastThirdPart.split(" ");

//   const cityName = city[0].trim();

//   if (cityName == "Sahibzada") {
//     return "Mohali";
//   }

//   return cityName;
// };

export const extractCityFromLocation = (assignedLocation) => {
  // Ensure the input is a valid string
  if (!assignedLocation || typeof assignedLocation !== "string")
    return "Unknown";

  const location = assignedLocation.toLowerCase();

  // Check for known Mohali-related locations
  if (
    location.includes("mohali") ||
    location.includes("kharar") ||
    location.includes("chandigarh") ||
    location.includes("daria")
  ) {
    return "Mohali";
  }

  // Check for Delhi-related locations
  if (location.includes("new delhi") || location.includes("delhi")) {
    return "Delhi";
  }

  // Split the location string by commas
  const locationParts = assignedLocation.split(",");

  // Try to get the third-last element (typically the city)
  const lastThirdPart =
    locationParts.length >= 3
      ? locationParts[locationParts.length - 3].trim()
      : "Unknown";

  const cityWords = lastThirdPart.split(" ");
  const cityName = cityWords[0].trim();

  // Handle special case
  if (cityName.toLowerCase() === "sahibzada") {
    return "Mohali";
  }

  return cityName || "Unknown";
};
